import { Component, inject } from '@angular/core';

import { NgTemplateOutlet } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'app-toasts',
    imports: [NgbToastModule],
    template: `
    @for (toast of toastService.toasts; track toast) {
    <ngb-toast
      [class]="toast.classname"
      [autohide]="true"
      [delay]="toast.delay || 5000"
      (hidden)="toastService.remove(toast)"
    >
      {{ toast.message }}
    </ngb-toast>
    }
  `,
    host: {
        class: 'toast-container position-fixed bottom-0 end-0 p-3',
        style: 'z-index: 1200',
    }
})
export class ToastsContainer {
  toastService = inject(ToastService);
}
